import type { LocalEditorRequest } from '@playcastdotio/Messaging';
import type { PeerCoordinator } from '../peer/PeerCoordinator';
import type { LocalHostApiRendererService } from '../../services/local-host-api/LocalHostApiRendererService';

interface VideoSession { clientId: string; sessionId: string; transportPeerId: string; generation: number }

export class LocalHostVideoSignalHandler {
  public constructor(private readonly peer: Pick<PeerCoordinator, 'handleLocalAdminSignal' | 'disconnectLocalPeer'>,
    private readonly renderer: Pick<LocalHostApiRendererService, 'send'>) {}
  public async handle(active: VideoSession, request: Extract<LocalEditorRequest, { op: 'signal' }>,
    current: () => boolean): Promise<void> {
    const { generation, transportPeerId } = active;
    if ((request.generation ?? 0) !== generation) return;
    const isCurrent = () => current() && active.generation === generation;
    try {
      await this.peer.handleLocalAdminSignal(transportPeerId, request.signal, signal => {
        if (isCurrent()) this.renderer.send(active.clientId, { v: 1, event: 'signal', sessionId: active.sessionId,
          ...(generation ? { generation } : {}), signal });
      });
    } catch (error) {
      if (isCurrent()) this.renderer.send(active.clientId, { v: 1, id: request.id, event: 'error',
        code: 'video_signaling_failed', message: error instanceof Error ? error.message : 'Video negotiation failed' });
    } finally {
      // Camera/SDP work can finish after its local session or video generation retired.
      if (!isCurrent()) this.peer.disconnectLocalPeer(transportPeerId);
    }
  }
}
